import { CrossType } from "@/src/components/CrossProductCard/types";
import { apiCallsModalStore } from "@/src/components/pages/StepPage/components/apiCalls/modalStore";
import { ApiCallModalType } from "@/src/components/pages/StepPage/components/apiCalls/types";
import { scrollToTop } from "@/src/components/Action/useNavigation";
import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";

export function crossesCheck(isValid: boolean, pickedCrosses: string[], isLegkiyCrossAllowed: boolean, router: AppRouterInstance) {
    if (!isValid) {
        scrollToTop(true);
        return;
    }
    const legkiyRegex = new RegExp(
        `^${CrossType.LegkyiZahyst}Premium_(\\d+)$`,
    );
    const dmsdtpRegex = new RegExp(
        `^${CrossType.DMSDTP}Premium_(\\d+)$`,
    );

    const hasInvalidLegkiy =
        pickedCrosses.some((cross: string) => legkiyRegex.exec(cross) !== null) && !isLegkiyCrossAllowed;

    const hasInvalidDmsdtp =
        pickedCrosses.some((cross: string) => dmsdtpRegex.exec(cross) !== null) && !isLegkiyCrossAllowed;

    if (hasInvalidLegkiy || hasInvalidDmsdtp) {
        let description = "";

        if (hasInvalidLegkiy && hasInvalidDmsdtp) {
            description = `Для обраного типу транспортного засобу неможливо придбати додаткові продукти на розширення ліміту відповідальності СВ+НВ та МС при ДТП, що були обрані Вами раніше.\nДля укладання договору страхування з урахуванням внесених змін, потрібно перейти на крок «Розрахунок»`;
        } else if (hasInvalidLegkiy) {
            description = `Для обраного типу транспортного засобу неможливо придбати додатковий продукт на розширення ліміту відповідальності СВ+НВ, що був обраний Вами раніше.\nДля укладання договору страхування з урахуванням внесених змін, потрібно перейти на крок «Розрахунок»`;
        } else if (hasInvalidDmsdtp) {
            description = `Для обраного типу транспортного засобу неможливо придбати додатковий продукт МС при ДТП, що був обраний Вами раніше.\nДля укладання договору страхування з урахуванням внесених змін, потрібно перейти на крок «Розрахунок»`;
        }

        apiCallsModalStore.getState().open(ApiCallModalType.ERROR, {
            description,
            onSubmit: () => {
                router.push("oscpv");
                apiCallsModalStore.getState().close();
            },
            submitText: "До розрахунку",
            title: "\u00A0",

            withCross: true,
        });
        throw new Error("Crosses are invalid");
    }
}